import axiosInstance from './axios.service';

/** Bank accounts ("cuentas de destino") — see backend/routes/cuentaBancaria.routes.js */
const cuentaBancariaService = {
  // Public — active accounts: { _id, nombre, beneficiario, esDefault }
  getPublic: async () => {
    const { data } = await axiosInstance.get('/api/cuentas/public');
    return Array.isArray(data) ? data : [];
  },
  // Admin
  getAll: async () => {
    const { data } = await axiosInstance.get('/api/cuentas');
    return Array.isArray(data) ? data : [];
  },
  create: async payload => {
    const { data } = await axiosInstance.post('/api/cuentas', payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await axiosInstance.put(`/api/cuentas/${id}`, payload);
    return data;
  },
  setDefault: async id => {
    const { data } = await axiosInstance.put(`/api/cuentas/${id}/default`);
    return data;
  },
  remove: async id => {
    const { data } = await axiosInstance.delete(`/api/cuentas/${id}`);
    return data;
  },
  setReservaCuenta: async (reservaId, cuentaId) => {
    const { data } = await axiosInstance.put(`/api/cuentas/reserva/${reservaId}`, {
      cuenta: cuentaId || null,
    });
    return data;
  },
  getReport: async ({ rifa } = {}) => {
    const params = rifa ? `?rifa=${encodeURIComponent(rifa)}` : '';
    const { data } = await axiosInstance.get(`/api/cuentas/report${params}`);
    return data;
  },
};

/** "Rugby — Tala Rugby Club" (beneficiary omitted when equal to the name). */
export function cuentaLabel(cuenta) {
  if (!cuenta) return '';
  const { nombre = '', beneficiario = '' } = cuenta;
  return beneficiario && beneficiario.trim() !== nombre.trim()
    ? `${nombre} — ${beneficiario}`
    : nombre;
}

export default cuentaBancariaService;
